module.exports = __webpack_public_path__ + "img/home-grid-info-k-volunteer.3f974e1b.png";